/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Tool_OverviewInputs */

const en_directory_tool_overview = /** @type {(inputs: Directory_Tool_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overview`)
};

const zh_directory_tool_overview = /** @type {(inputs: Directory_Tool_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`概述`)
};

/**
* | output |
* | --- |
* | "Overview" |
*
* @param {Directory_Tool_OverviewInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_tool_overview = /** @type {((inputs?: Directory_Tool_OverviewInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Tool_OverviewInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_tool_overview(inputs)
	return zh_directory_tool_overview(inputs)
});
export { directory_tool_overview as "directory.tool.overview" }